import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import InfoProcessing, { IProps } from './index';

const mapStateToProps = (state: ApplicationState): IProps => {
  return {
    complete: state.student.core.legalAdviseDisclaimer,
    legalAdviseDisclaimer: state.student.core.legalAdviseDisclaimer,
    config: state.student.config,
  };
};

export default connect(mapStateToProps)(InfoProcessing);
